import React from 'react';
// import { Lead, BSpan } from 'react-bootstrap';
import { Authenticator, CheckboxField } from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
// import { KnownUser } from '../components/auth';
// import { VerifyUser } from '../components/utils';
import { Auth, I18n } from 'aws-amplify';
import { translations, useAuthenticator, TextField, Text } from '@aws-amplify/ui-react';
// import { Container } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

I18n.putVocabularies(translations);
I18n.setLanguage('de');

// https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/de.ts
I18n.putVocabularies({
  de: {
    'Your code is on the way. To log in, enter the code we emailed to': 'Ihr Zugangs-Code ist auf dem Weg. Zum Einloggen, tragen Sie bitte den Code ein, den wir Ihnen gemailt haben',
    'Your code is on the way. To log in, enter the code we texted to': 'Ihr Zugangs-Code ist auf dem Weg. Zum Einloggen, tragen Sie bitte den Code ein, den wir Ihnen per SMS geschickt haben',
    'Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive.': 'Ihr Zugangs-Code ist auf dem Weg. Zum Einloggen, tragen Sie bitte den Code ein, den wir Ihnen per zugeschickt haben Es kann einige Minuten dauern.',
    'It may take a minute to arrive.': 'Es kann einige Minuten dauern.',
    'Cannot reset password for the user as there is no registered/verified email or phone_number': 'Das Passwort kann nicht zurückgesetzt werden, da es für diesen Benutzer keine registrierte Email-Adresse gibt.',
    'Invalid verification code provided, please try again.': 'Ungültiger Zugangs-Code, bitte nochmal versuchen.',
    'Incorrect username or password.': 'Falsche Email-Adresse oder falsches Passwort.',
    'Reset your password': 'Zurücksetzen des Passwortes',
    'Reset your Password': 'Zurücksetzen des Passwortes',
    'Password cannot be empty': 'Das Passwort darf nicht leer sein',
    'Password must have at least 8 characters': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    'Your passwords must match': 'Ihr Passwort muss übereinstimmen.',
    'We Sent A Code': 'Wir haben einen Code abgeschickt',
    'String must be no longer than 10 characters': 'Bitte nicht mehr als 10 Zeichen.'
  },
});

const OK = true;
const checkDate = (date)  => {
  // console.log('Datum:', date)
  const separator = '.';
  const bits = date.split(separator);
  const d = new Date(bits[2], bits[1] - 1, bits[0])
  // console.log(`${d}: ${d.getFullYear()}.${d.getMonth() +1}:: ${bits[2]}, ${bits[1]}, ${bits[0]}`)
  return d.getFullYear() === parseInt(bits[2]) && d.getMonth() + 1 === parseInt(bits[1]);
}

const checkNumber = (inp) => {
  const reg = /^[0-9]*$/;
  // console.log('Test Input', inp, reg.test(inp))
  return reg.test(inp);
}

const services = {
  async validateCustomSignUp(formData) {
    // console.log(formData)
    if (!formData['custom:birthdate']) {
      return {
        'custom:birthdate': 'Das Geburtsdatum darf nicht leer sein.',
      }
    }
    if ((formData['custom:birthdate']).length > 10) {
      return {
        'custom:birthdate': 'Bitte ein gültiges Geburtsdatum eingeben (zu lang).',
      }
    }
    if ((formData['custom:birthdate']).length < 10) {
      return {
        'custom:birthdate': 'Bitte ein gültiges Geburtsdatum eingeben (zu kurz).',
      }
    }
    if (checkDate(formData['custom:birthdate']) !== OK) {
      return {
        'custom:birthdate': 'Bitte ein gültiges Geburtsdatum eingeben.',
      }
    }
    if (!formData['custom:kvsID']) {
      return {
        'custom:kvsID': 'Die ID darf nicht leer sein.',
      };
    }
    if (formData['custom:kvsID'][0] === '0') {
      return {
        'custom:kvsID': 'Keine führenden Nullen bitte!',
      };
    }
    // console.log('CheckNumber returns:', checkNumber(formData['custom:kvsID']));
    if (checkNumber(formData['custom:kvsID']) !== OK) {
      return {
        'custom:kvsID': 'Nur Ziffern bitte!',
      };
    }
    if (formData['custom:acknowledgements'] !== 'yes') {
      return {
        'custom:acknowledgements': 'Sie müssen Ihr Einverständnis erklären um einen Account zu bekommen.',
      };
    }
  },
  async handleSignUp(formData) {
    let { username, password, attributes } = formData;
    // custom attribute ID must be set to zero by default
    attributes['custom:ID'] = 0;
    // console.log('handleSignUp: ', attributes);
    return Auth.signUp({
      username,
      password,
      attributes,
    });
  }/*,
  async handleConfirmSignUp(formData) {
    let {username, code} = formData;
    try {
      const {result} = await Auth.confirmSignUp(username, code);
      console.log(result)
      alert("Der Account wurde erfolgreich erstellt.");
      return { route: 'signedUp' }
      // window.Location = '/';
    } catch (error) {
      console.log('Fehler beim Erstellen des Accounts', error);
      alert(error.message);
    }
  } */
};

const formFields = {
  signUp: {
    email: {
      order: 1,
      labelHidden: false,
      placeholder: 'Email',
      isRequired: true,
      label: 'Email'
    },
    name: {
      order: 2,
      labelHidden: false,
      placeholder: 'Vorname',
      isRequired: true,
      label: 'Vorname'
    },
    family_name: {
      order: 3,
      labelHidden: false,
      placeholder: 'Nachname',
      isRequired: true,
      label: 'Nachname'
    },
    password: {
      order: 6
    },
    confirm_password: {
      order: 7
    }
  },
}

const formComponents = {
  SignUp: {
    FormFields() {
      const { validationErrors } = useAuthenticator(context => [context.validationErrors]);

      return (
        <React.Fragment>
          <Text as='p' style={{textAlign: 'center'}}>Beachten Sie bitte, dass Ihr Patienten-Account erst dann freigeschaltet werden kann, wenn Sie von uns eine schriftliche Einladung erhalten und die Daten aus dieser Einladung hier eingetragen haben.</Text>
          <Authenticator.SignUp.FormFields />
          <TextField
            errorMessage={validationErrors['custom:birthdate']}
            hasError={!!validationErrors['custom:birthdate']}
            name="custom:birthdate"
            placeholder='01.01.1987'
            label='Geburtstag'
          />
          <TextField
            errorMessage={validationErrors['custom:kvsID']}
            hasError={!!validationErrors['custom:kvsID']}
            name="custom:kvsID"
            type="text"
            min={0}
            step={'any'}
            pattern="^[0-9]*$"
            placeholder='ID'
            label='ID'
          />
          <CheckboxField
            errorMessage={validationErrors['custom:acknowledgements']}
            hasError={!!validationErrors['custom:acknowledgements']}
            name="custom:acknowledgements"
            value='yes'
            label="Ich bin damit einverstanden, dass die Kliniken Dr. Vötisch GmbH meine E-Mail-Adresse zur Erstellung des Accounts speichert und zum Zweck der Kommunikation mit mir nutzt. Ich kann die Einwilligung jederzeit durch Löschen des Accounts widerrufen."
          />
        </React.Fragment>
      );
    }
  }
}

const Authentication = () => <Authenticator loginMechanisms={['email']} services={services} formFields={formFields} components={formComponents} />;

/*
const Hello = () => {
  return (
    <Container className='starter-template' >
      <h2>Sie sind angemeldet als <div font="italic"><KnownUser /></div></h2>
      <VerifyUser />
    </Container>

  )
}
*/

const Login = (props) => {
  const { route } = useAuthenticator((context) => [context.route]);
  // console.log(route)
  return route === 'authenticated' ? <Navigate to='/' replace={true} /> : route === 'signedUp' ? <Navigate to='/profile' replace={true} /> : <Authentication />;
}

export default Login;